import Button from "components/Button";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import ReactDOM from "react-dom";
import SecondCheckbox from "components/SecondCheckbox";
import { useEffect, useState } from "react";

const ConfirmModal: FC<Props> = ({
  title,
  text,
  onAccept,
  onCancel,
  acceptLabel,
  cancelLabel,
  Icon,
  showDontShowNextTime = true,
}) => {
  const [value, setValue] = useState(false);

  // „ask" = „Nie pokazuj tego komunikatu" przy usuwaniu na Dysku. Zapisujemy tylko, gdy
  // checkbox jest widoczny — inaczej każdy modal bez niego kasował tę preferencję.
  useEffect(() => {
    if (!showDontShowNextTime) return;
    localStorage.setItem("ask", String(value));
  }, [value, showDontShowNextTime]);

  return ReactDOM.createPortal(
    <div className={styles.modal}>
      <div className={styles.wrapper}>
        {Icon && (
          <div className={styles.icon}>
            <Icon></Icon>
          </div>
        )}
        <div className={styles.title}>{title}</div>
        <div className={styles.body}>{text}</div>

        {showDontShowNextTime && (
          <div className={styles.checkbox}>
            <SecondCheckbox onChange={() => setValue(!value)} value={value} />{" "}
            Nie pokazuj tego komunikatu
          </div>
        )}

        <div className={styles.buttonsWrapper}>
          <div onClick={onCancel} className={styles.button}>
            {cancelLabel}
          </div>
          <Button
            className={styles.buttonColor}
            onClick={onAccept}
            text={acceptLabel}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
